export const alphabetsRgex = /^[a-zA-Z ]*$/;
export const serviceNameRegex = /^[a-zA-Z0-9!@#$%^&*(){}\[\]/|\\\-',.\s]*$/;
export const alphabetsDotSpaceRgex = /^[a-zA-Z., ]+$/;
export const alphabetsNumDotUnderscoreHyphenRgex = /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?$/;
export const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!#$%&`~?@':;^/.<>,|])[a-zA-Z0-9!#$%&`~?@':;^/.<>,{}()|]{8,30}$/;
export const mobileNoRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
export const phoneNoRegex = /^(\+\d{1,3}[- ]?)?\d{7}$/;
export const pricingRegex = /^\d*$/;
export const facebookRegex = /(?:https?:\/\/)?(?:www\.)?facebook\.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:\w*\/)*(\w*)/;
export const twitterRegex = /http(?:s)?:\/\/(?:www\.)?(?:twitter\.com|x\.com)\/(\w+)/;
export const linkedinRegex = /https?:\/\/(www\.)?linkedin\.com\/?(\S+)?(:\d+)?(\/[\w#:.?+=&%@/-]*)?/;
export const emailRegex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
export const alphabetsNumberRegex=/^[a-zA-Z0-9]*$/;